import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";

import { TToastMessage, ToastService } from "@app/core/services/toast.service";

@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent{
  constructor(
    public toastService: ToastService,
  ) {}
   isVisible = false;
  cleanToasts(): void {
    this.toastService.dismissAll();
  }

  removeToast(id: string): void {    
    this.toastService.removeToast(id);
  }

  dismissAll(): void {
    this.toastService.dismissAll();
  }

  trackByToastId(_: number, toast: TToastMessage): string {
    return toast.id;
  }

  getIconPath(type: string): string {
    switch (type) {
      case "error":
        return "./icons/red-icon.png";
      case "success":
        return "./icons/green-icon.png";
      case "info":
        return "./icons/blue-icon.png";
      default:
        return "./icons/blue-icon.png";
    }
  }

  getIconAlt(type: string): string {
    switch (type) {
      case "error":
        return "Error icon";
      case "success":
        return "Success icon";
      case "info":
        return "Info icon";
      default:
        return "Info icon";
    }
  }
}